import Vue from 'vue';
import Vuex from 'vuex';
import {ajax} from 'resource/lib/ajax';

Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        cityInfo: {},
        userInfo: {},
        customerInfo: {},
    },
    mutations: {
        setCityInfo(state,data) {
            state.cityInfo = data
        },
        setUserInfo(state,data) {
            state.userInfo = data
        },
        setCustomerInfo(state,data) {
            state.customerInfo = data;
        }
    },
    actions: {
        //获取用户、当前地址信息
        async getBaseInfo({ commit }) {
            ajax.get("/api/common/baseInfo").then(res => {
                commit('setUserInfo', res.data.userInfo);
                commit('setCityInfo', res.data.locationInfo);
            })
        },
        //获取顾问信息
        async getCustomerInfo({ commit }) {
            return new Promise((resolve,reject) =>{
                ajax.get("/api/stewardInfoService/getStewardInfoEdit").then(res => {
                    let result = res.data;
                    commit('setCustomerInfo', result.data || null);
                    resolve(result);
                }).catch(err => {
                    console.log(err);
                    resolve({
                        success: false
                    });
                })
            })
            
        },
    },
    modules: {
    }
});

export default store;
